<!-- 备品备件列表 -->
<template>
  <a-modal :title="title" :width="width" @cancel="handleCancel" @ok="handleOk" class="define-class" v-model="visible">
    <template slot="footer">
      <a-button @click="handleOk" type="primary">确认</a-button>
      <a-button @click="handleCancel">取消</a-button>
    </template>
    <!-- :pagination="ipagination" -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="getData" layout="inline">
        <a-row :gutter="24">
          <a-col :md="8" :sm="12">
            <a-form-item label="名称">
              <a-input allowClear placeholder="请输入备件名称" v-debounce="getData" v-model="queryParam.bjName" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="12">
            <a-form-item label="型号">
              <a-input allowClear placeholder="请输入备件型号" v-debounce="getData" v-model="queryParam.bjModel" />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="getData" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <a-tabs @change="switchType" style="background-color: #fff;" v-model="activeKey">
      <a-tab-pane :key="tab.key" :tab="tab.name" v-for="tab in tabs">
        <!-- x: `${columns.length}0%`, -->
        <a-table
          :columns="columns"
          :dataSource="tableData[tab.key]"
          :loading="loading"
          :pagination="false"
          :rowKey="(record, index) => {record.id + index}"
          :scroll="{
            y:350
          }"
          @change="handleTableChange"
          bordered
          class="j-table-force-nowrap"
          ref="table"
          size="middle"
        >
          <template slot="count" slot-scope="text, record">
            <a-input-number :default-value="0" :max="10000" :min="0" @change="onChange($event,record)"></a-input-number>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { filterObj } from '@/utils/util';

  export default {
    name: 'DevBpbjInfoList',
    mixins: [JeecgListMixin, mixinDevice],
    props: {
      width: {
        default: 1080,
      },
      title: {
        type: String,
        default: '消耗备件'
      },
      repairPlanId: {
        type: String,
        default: ''
      },
      taskTable: {
        type: String,
        default: 'maintain'
      },
    },
    data () {
      return {
        queryParam: {},
        description: 'dev_bpbj_info管理页面',
        tabs: [{
          name: '标准库已适配',
          key: '1',
        }, {
          name: '通用型备件',
          key: '2',
        }],
        activeKey: '1',
        visible: false,
        // 表头
        columns: [
          {
            title: '备件名称',
            align: "center",
            dataIndex: 'bjName',
            width: 160,
          },
          {
            title: '备件型号',
            align: "center",
            dataIndex: 'bjModel',
            width: 160,
          },
          {
            title: '备件型号规格',
            align: "center",
            dataIndex: 'bjModelSpec',
          },
          {
            title: '使用数量',
            align: "center",
            dataIndex: 'count',
            width: 80,
            scopedSlots: { customRender: 'count' }
          },
          {
            title: '库存数量',
            align: "center",
            dataIndex: 'leftCount',
            width: 80,
          },
          {
            title: '单位',
            align: "center",
            dataIndex: 'unit',
            width: 50,
          },
        ],
        dictOptions: {},
        superFieldList: [],
        url: {
          list: "/spareparts/devBpbjInfo/list",
          devFilterList: '/spareparts/devBpbjInfo/app/list',
        },
        actionDevice: {},
        tableData: [],
        bjModelId: '',
      }
    },
    created () {
      // this.getSuperFieldList();
    },
    methods: {
      getData () {
        const params = {
          devId: this.actionDevice.devId,
          pageNo: 1,
          pageSize: 100000,
          bjName: this.queryParam.bjName,
          type: this.activeKey,
        }
        // this.bjModelId = data.id data.devId
        this.loading = true
        getAction(this.url.devFilterList, params).then(res => {
          this.loading = false
          if (res.success) {
            this.tableData['2'] = res?.result?.all?.records || [];
            this.tableData['1'] = res?.result?.match?.records || [];
          }
        }).catch(() => {
          this.loading = false
        })
      },
      switchType () {
        if (!this.tableData[this.activeKey].length) {
          this.getData();
        }
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'bjCode', text: '备件物资编码' })
        fieldList.push({ type: 'string', value: 'bjName', text: '备件名称' })
        fieldList.push({ type: 'string', value: 'bjModel', text: '备件型号' })
        fieldList.push({ type: 'string', value: 'bjModelSpec', text: '备件型号规格' })
        fieldList.push({ type: 'number', value: 'prepareCount', text: '应备数量' })
        fieldList.push({ type: 'string', value: 'unit', text: '单位' })
        fieldList.push({ type: 'string', value: 'devClassId', text: '设备类型' })
        fieldList.push({ type: 'string', value: 'manuId', text: '设备厂家' })
        fieldList.push({ type: 'string', value: 'devModelId', text: '设备型号' })
        fieldList.push({ type: 'int', value: 'ageMonth', text: '寿命' })
        fieldList.push({ type: 'number', value: 'leftCount', text: '初始数量' })
        fieldList.push({ type: 'string', value: 'ywUnit', text: '运维单位' })
        fieldList.push({ type: 'int', value: 'delFlag', text: '删除状态' })
        this.superFieldList = fieldList
      },
      handleOk () {

        // 找出 使用数量不为0 的 备件
        const result1 = this.tableData['1'].filter(item => item.count > 0);
        const result2 = this.tableData['2'].filter(item => item.count > 0);
        const result = [...result1, ...result2];
        if (result.length == 0) {
          this.$message.warning('未检测到使用备件，请修改“使用数量”完成领用')
          return false
        }
        this.$emit('refresList', result.map(res => {
          res.taskTable = this.taskTable
          res.devId = this.actionDevice.devId //this.bjModelId
          res.devName = this.actionDevice.devName
          return res
        }))
        this.handleCancel()
      },
      handleCancel () {
        this.visible = false
        this.tableData = []
      },
      open (data) {
        this.actionDevice = {
          devId: data.devId,
          devName: data.devName
        }
        this.visible = true
        this.getData()
      },
      onChange (value, item) {
        item.count = value
      },
      //   save (params) {
      //     return httpAction('/spareparts/devBpbjLeadoutRecord/saveBpbjLeadoutRecord', params, 'post')
      //       .then(res => {
      //         if (res.success) {
      //           this.$message.success(res.message)
      //           return res
      //         } else {
      //           this.$message.error(res.message)
      //           return Promise.reject()
      //         }
      //       })
      //   },
      getQueryParams () {
        var param = Object.assign({}, this.queryParam, this.isorter);
        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        if (this.superQueryParams) {
          param['superQueryParams'] = encodeURI(this.superQueryParams)
          param['superQueryMatchType'] = this.superQueryMatchType
        }
        return filterObj(param);
      },
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>
<style lang="less" scoped>
  .define-class {
    .ant-card-body .table-operator {
      margin-bottom: 18px;
    }
    .ant-table-tbody .ant-table-row td {
      padding-top: 15px;
      padding-bottom: 15px;
      white-space: break-spaces !important;
    }
    .anty-row-operator button {
      margin: 0 5px;
    }
    .ant-btn-danger {
      background-color: #ffffff;
    }

    .ant-modal-cust-warp {
      height: 100%;
    }
    .ant-modal-cust-warp .ant-modal-body {
      height: calc(100% - 110px) !important;
      overflow-y: auto;
    }
    .ant-modal-cust-warp .ant-modal-content {
      height: 90% !important;
      overflow-y: hidden;
    }
    .ant-input-number {
      width: 60px;
    }
  }
</style>